import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaTrashAlt, FaPlus } from 'react-icons/fa';
import Selector from "../../../DynamicComp/Selector";
import Button from "../../../DynamicComp/Button";
import GenericTable from "../../../DynamicComp/Table";
import logo from "../../../../Assets/white arrow.png";
import { getData, postData } from "../../../../global/Globalapi";
import { showAlert } from "../../../DynamicComp/Alert";
const FeaturesMapping = () => {
    const [formData, setFormData] = useState({
        groupName: '',
        selectedcomponents: [],
    });
    const [product_typedata, setData] = useState([]);
    const [productdata, setPdtMasData] = useState([]);
    const [component_data, setCompData] = useState([]);
    const [editId, setEditId] = useState(null);
    const [filteredMasters, setFilteredMasters] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [data,setdata] = useState({});



    const fetchData = async () => {
        try {
            const response = await getData('/product_type');
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchProdMasData = async () => {
        try {
            const response = await getData('/product');
            setPdtMasData(response.data);

            console.log(response.data, 'check productMasDATA')
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchCompData = async () => {
        try {
            const response = await getData('/component');
            setCompData(response.data);
            //   console.log(component_data, "DataC");
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchProdMasData();
        fetchCompData();
    }, []);
    const handleGroupChange = (selectedGroup) => {
        setFormData({ ...formData, groupName: selectedGroup });

        // Filter productdata based on selected product group
        const filtered = productdata.filter(master => master.product_type_id === selectedGroup);
        setFilteredMasters(filtered);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData, "compId");
        try {
            const response = await postData(
                '/addComponentMap',
                formData
            );
            showAlert({
             type: 'success',
             message: response.data.message || 'Operation completed successfully ✅',
            title: 'success',
            });


        } catch (error) {
            console.error(error);
        }
    };
    const columns = [
        {
            key: "sno",
            label: "S.No",
            sortable: false,
            align: "center",
            width: "80px"
        },
        { key: "attribute_name", label: "Component", sortable: false },
        {
            key: "actions",
            label: "Actions",
            align: "center",
            width: "120px",
        },
    ];
    const customRenderers = {
        actions: (row, { selectedRows, setSelectedRows }) => {
            if (!selectedRows || !setSelectedRows) {
                console.error("selectedRows or setSelectedRows is undefined.");
                return null;
            }
            const isSelected = selectedRows.includes(row.attribute_id);
            return (
                <div className="flex justify-center">
                    <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {
                            const updatedSelection = isSelected
                                ? selectedRows.filter((id) => id !== row.attribute_id)
                                : [...selectedRows, row.attribute_id];

                            setSelectedRows(updatedSelection);
                        }}
                        className="w-4 h-4 cursor-pointer"
                    />
                </div>
            )
        }
    };

    return (
        <div className="flex flex-col items-center min-h-screen w-full p-8 bg-gray-50">
            <div className="bg-white p-6 rounded-xl shadow-lg w-full">
                <h2 className="text-2xl font-bold text-black flex-grow  mb-4">Components Mapping</h2>
                <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6">

                    {/* First Row - Product Group */}
                    <div className="flex justify-center">
                        <div className="w-1/3">
                            <label className="text-gray-700 font-semibold">
                                Product Group
                            </label>
                            <Selector
                                className="overflow-auto z-50 w-full"
                                options={product_typedata.map(group => ({
                                    value: group.product_type_id,
                                    label: group.ProductGroupName
                                }))}
                                value={formData.groupName}
                                onChange={handleGroupChange}
                                placeholder="Select Product Group"
                            />

                        </div>
                        {/* <Button variant="danger" className="px-2 py-1 text-xs !h-8 !w-15 "><img src={logo} className="w-6 h-6" alt="logo"></img></Button> */}
                        <Button
                            variant="danger"
                            className="px-2 py-1 text-xs !h-8 !w-15"
                            onClick={async () => {
                                if (!formData.groupName) {
                                    showAlert({
                              type: 'warning',
                              message: data.message || "Please select a product group frist",
                              title: 'warning',
                            });
                                    return;
                                }

                                try {
                                    const response = await getData(`/getComponentMap/${formData.groupName}`);
                                    const compIds = response.data.map(item => item.attribute_id); // assuming response has array of attribute_id
                                    setFormData(prev => ({
                                        ...prev,
                                        selectedcomponents: compIds
                                    }));
                                } catch (error) {
                                    console.error("Error fetching mapped components:", error);
                                }
                            }}
                        >
                            <img src={logo} className="w-6 h-6" alt="logo" />
                        </Button>

                    </div>

                    {/* Second Row - Table */}
                    <div className="w-full flex justify-center mt-12">
                        <GenericTable
                            columns={columns}
                            data={component_data}
                            customRenderers={customRenderers}
                            headerClassName="bg-red-700 text-white"
                            rowKey="attribute_id"
                            stripedRows={true}
                            hoverEffect={true}
                            rowsPerPageOptions={[5, 10, 20]}
                            selectedRows={formData.selectedcomponents}
                            setSelectedRows={(updatedSelected) =>
                                setFormData(prev => ({
                                    ...prev,
                                    selectedcomponents: updatedSelected
                                }))
                            }
                        />
                    </div>

                    {/* Third Row - Add Button */}
                    <div className="flex justify-center">
                        <Button
                            variant="danger"
                            type="submit"
                            className="px-6 py-2 rounded-lg"
                        >
                            Save
                        </Button>
                    </div>


                </form>
            </div>
        </div>

    )
}

export default FeaturesMapping;